import Vue from 'vue'
import Vuex from 'vuex'
import authStore from './modules/authStore'
import fighthers from './modules/fighters'

Vue.use(Vuex)

export default new Vuex.Store({
   modules: {
      authStore,
      fighthers
   }
});
